import axios from "axios";
import { API_BASE_URL3, API_BASE_URL1 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");
import axiosInstance from "../../Hooks/axoisInstance";
import { toast } from "react-toastify";
const getToken = () => {
  return localStorage.getItem("token");
};

export const GetAllRoles = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllRoles`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const CreateUsers = async (userData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL3 + `Authentication/Register`,
      userData,
      {
        headers: {
          // 'Content-Type': 'multipart/form-data',
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    // console.log(response.data, 'user response create')
    return response;
  } catch (error) {
    throw error;
  }

  // if (!response.ok) {
};

export const UpdateUsers = async (userData) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL3 + `Authentication/UpdateRegister`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    console.log(response.data, "user update");
    // toast.success('Zone updated Successfully!', {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })

    // if (!response.ok) {
    //   throw new Error("Failed to update zone");
    // }

    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdatePassword = async (userID, password) => {
  try {
    const response = await axiosInstance.put(
      API_BASE_URL1 + `Authentication/UpdatePassword`,
      {
        userId: userID,
        password: password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const GetAllUsers = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetAllUsers`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const GetCircleByMultipleZoneId = async (zoneIds) => {
  try {
    // Generate the query string with multiple ZoneIds
    const zoneIdsQuery = zoneIds.map((id) => `ZoneIds=${id}`).join("&");
    const response = await axiosInstance.get(
      API_BASE_URL1 + `MasterDetails/GetCircleByMultipleZoneId?${zoneIdsQuery}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching circles by zone IDs:", error);
    throw error;
  }
};
export const GetWardByMultipleCircleId = async (circleIds) => {
  try {
    // Generate the query string with multiple ZoneIds
    const circleIdsQuery = circleIds.map((id) => `CircleIds=${id}`).join("&");
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `MasterDetails/GetWardByMultipleCircleId?${circleIdsQuery}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching wards by zone IDs:", error);
    throw error;
  }
};

export const GetAllActiveUsers = async (UserType) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `DashboardReport/ActiveUsers?UserType=${UserType}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllUserTypes = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllUserType`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllTertiaryTripReport = async (queryParams) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeployment/GetRawTertiaryTripTransactions?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAllTertiaryDeploymentReport = async (queryParams) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeployment/GetRawTertiaryDeployments?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllDeploymentSummaryReport = async (shiftId, FromDate,ToDate, transferStationName = "",selectedOwnerType,selectedVehicleType) => {
  
  const ownerId = selectedOwnerType == null ? '' : selectedOwnerType;
  const vehicleId = selectedVehicleType == null ? '' : selectedVehicleType;
  
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetDeploymentSummaryReport?ShiftId=${shiftId}&FromDate=${FromDate}&ToDate=${ToDate}&TransferStationName=${transferStationName}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllTertiaryDeploymentReport = async (queryParams) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetDeploymentReport?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllTertiaryTripReport = async (queryParams) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetTertiaryTripReport?${queryParams}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllInnerReportDeployedJN = async (
  transferStationId,
  fromDate,
  toDate,
  ShiftId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetTertiaryDeploymentInnerReport?DestinationTransferStationId=${transferStationId}&ReportType=2&FromDate=${fromDate}&ToDate=${toDate}&ShiftId=${ShiftId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllInnerReportDeployedHalting = async (
  transferStationId,
  fromDate,
  toDate,
  ShiftId,
  ownerId,
  vehicleId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetTertiaryDeploymentInnerReport?DestinationTransferStationId=${transferStationId}&ReportType=3&FromDate=${fromDate}&ToDate=${toDate}&ShiftId=${ShiftId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllInnerReportOfTotalDeployment = async (
  transferStationId,
  fromDate,
  toDate,
  ShiftId,
  ownerId,
  vehicleId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetTertiaryDeploymentInnerReport?DestinationTransferStationId=${transferStationId}&ReportType=4&FromDate=${fromDate}&ToDate=${toDate}&ShiftId=${ShiftId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const AllInnerReportDeployedTS = async (
  transferStationId,
  fromDate,
  toDate,
  ShiftId,
  ownerId,
  vehicleId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TertiaryDeploymentReport/GetTertiaryDeploymentInnerReport?DestinationTransferStationId=${transferStationId}&ReportType=1&FromDate=${fromDate}&ToDate=${toDate}&ShiftId=${ShiftId}&OwnerTypeId=${ownerId}&VehicleTypeId=${vehicleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
